import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { STATUSES, useInspectionStats, useInspections } from '../../api/inspections';
import { useEnumLabel } from '../../api/enums';
import { useMe } from '../../api/me';
import { ButtonLink } from '../../components/idsk';
import { PageHeading } from '../../layout/PageHeading';
import { usePageTitle } from '../../layout/usePageTitle';
import { formatNumber } from '../../lib/format';
import { QueryError } from '../common/QueryError';
import { Loading } from '../common/LoadingPage';
import { InspectionTable } from '../inspections/InspectionsListPage';

/** ADMIN: all inspections with counts per status. INSPECTOR: "Moje inšpekcie". */
export function HomePage() {
  const { t } = useTranslation();
  const me = useMe().data;
  const label = useEnumLabel();
  const admin = me?.admin ?? false;
  const title = admin ? t('home.adminTitle') : t('home.inspectorTitle');
  usePageTitle([title]);
  const stats = useInspectionStats();
  const recent = useInspections({ page: 0, size: 10, sort: 'dateFrom,desc' });
  return (
    <>
      <PageHeading>{title}</PageHeading>
      <p className="govuk-body">{t('home.welcome', { name: me?.displayName ?? '' })}</p>
      {admin && (
        <p className="govuk-body">
          <ButtonLink to="/inspekcie/nova">{t('inspections.add')}</ButtonLink>
        </p>
      )}
      <h2 className="govuk-heading-m">{t('home.countsHeading')}</h2>
      {stats.error ? (
        <QueryError error={stats.error} />
      ) : stats.isPending ? (
        <Loading />
      ) : (
        <ul className="app-status-counts" aria-label={t('home.countsHeading')}>
          {STATUSES.map((s) => (
            <li key={s}>
              <Link className="govuk-link" to={`/inspekcie?status=${s}`}>
                <span className="app-count">{formatNumber(stats.data.counts[s] ?? 0)}</span>
                {label('inspectionStatuses', s)}
              </Link>
            </li>
          ))}
        </ul>
      )}
      <h2 className="govuk-heading-m">{admin ? t('home.recentAll') : t('home.recentMine')}</h2>
      {recent.error ? (
        <QueryError error={recent.error} />
      ) : recent.isPending ? (
        <Loading />
      ) : (
        <>
          <InspectionTable rows={recent.data.content} caption={admin ? t('home.recentAll') : t('home.recentMine')} />
          <p className="govuk-body">
            <Link className="govuk-link" to="/inspekcie">
              {t('home.allInspections', { count: recent.data.totalElements })}
            </Link>
          </p>
        </>
      )}
    </>
  );
}
